import React, { useState } from 'react'
import './HeroSectionBox.css'
import hero from '../image/club/hero-img.jpg'
import { FaLocationDot } from "react-icons/fa6";
import { API_BASE_URL } from '../../utils';
import FooterAppDownloadModal from '../../Feed Page/custom-comp/FooterAppDownloadModal';

function HeroSectionBox({ data, isPartyPackege }) {

    const url = `${API_BASE_URL}/master/assets/uploads/`;

    const [showModal, setShowModal] = useState(false);


    return (
        <>
            <div className="vcdp-HeroSectionBox">
                <div className="vcdp-container">

                    <div className="vcdp-hero-img-section">
                        <div className="vcdp-hero-img">

                            {isPartyPackege ? (
                                <>
                                    {data?.thumbnail ? (
                                        <img src={`${url}${data.thumbnail} `} alt="Banner" />)
                                        : (
                                            <img src={hero} alt="Default Banner" />
                                        )}
                                </>
                            ) : (
                                <>
                                    {Array.isArray(data?.banner) && data.banner.length > 0 ? (
                                        <img src={`${url}${data.banner[0].img}`} alt="Banner" />
                                    ) : (
                                        <img src={hero} alt="Default Banner" />
                                    )}
                                </>
                            )}



                            <div className='vcdp-hero-img-overlay-bg'></div>
                            <div className="vcdp-hero-text-overlay">
                                <div className="vcdp-hero-text-1">
                                    {
                                        isPartyPackege ? (
                                            <>
                                                <h3>{data?.title}</h3>
                                                <span>{data?.clubName}</span>
                                            </>
                                        ) : (
                                            <h3>{data?.name}</h3>
                                        )
                                    }
                                    <h5><FaLocationDot />{data?.address}</h5>
                                    <p>{data?.about?.description}</p>

                                </div>
                                <div className="vcdp-hero-text-2">
                                    <h4>Open from {data?.open_time}</h4>
                                    <h4>Close from {data?.close_time}</h4>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="vcdp-HeroSectionBox-content">
                        <div className='vcdp-HeroSectionBox-content-text'>
                            <h3>Enroll in Crown Membership – Free Passes Await! </h3>
                            <h5>Book Through PartyWitty App</h5>
                        </div>
                        <div className='vcdp-HeroSectionBox-content-btn'>
                            <button className='vcdp-hero-btn' onClick={() => setShowModal(true)}>Reserve Now</button>
                        </div>
                    </div>


                </div>
            </div>
            <FooterAppDownloadModal isOpen={showModal} onClose={() => setShowModal(false)} />
        </>
    )
}

export default HeroSectionBox
